import { Route, Switch } from "react-router-dom";

import CancelManageComponent from "../../components/page/salesManage/CancelManageComponent";
import DeliveryManageComponet from "../../components/page/salesManage/DeliveryManageComponet";
import OrderCompleteComponent from "../../components/page/salesManage/OrderCompleteComponent";
import OrderCreateComponent from "../../components/page/salesManage/OrderCreateComponent";
import OrderGiftComponent from "../../components/page/salesManage/OrderGiftComponent";
import OrderSearchComponent from "../../components/page/salesManage/OrderSearchComponent";
import ReturnManage from "../../components/page/salesManage/ReturnManage";
import SalesManageSearchComponent from "../../components/page/salesManage/SalesManageSearchComponent";

const SalesManagePage = () => {
  return (
    <Switch>
      <Route
        path="/salesManage/order/create"
        component={OrderCreateComponent}
      />
      <Route
        path="/salesManage/search"
        component={SalesManageSearchComponent}
      />
      <Route path="/salesManage/order" component={OrderSearchComponent} />
      <Route path="/salesManage/gift" component={OrderGiftComponent} />
      <Route path="/salesManage/delivery" component={DeliveryManageComponet} />
      <Route
        path="/salesManage/purchaseComfirmation"
        component={OrderCompleteComponent}
      />
      <Route path="/salesManage/cancel" component={CancelManageComponent} />
      <Route path="/salesManage/return" component={ReturnManage} />
      {/*<Route path="/salesManage/exchange" component={}/>*/}
    </Switch>
  );
};

export default SalesManagePage;
